import Category from "../Category";
import MenuItemBuilder from "../MenuItemBuilder";
import {addOnOptions} from "../AddOnOptions";

export default new Category('Chef\'s Specialties', 'images/categories/chef.jpg')
    .setDescription('Served w/ White Rice')
    .addMenuItem(new MenuItemBuilder('Happy Family', 11.95)
        .setDescription('Shrimp, crab meat, scallops, beef, pork & chicken blended w/ broccoli, baby corn, straw mushrooms & chinese vegetable in brown sauce.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Seafood Delight', 10.95)
        .setDescription('Shrimp, crab meat, scallops & chinese vegetable in white sauce.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Four Seasons', 10.95)
        .setDescription('A savory blend of shrimp, chicken, pork & beef w/ variety of chinese vegetable in seasons.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Triple Delight', 9.95)
        .setDescription('Jumbo shrimp, chicken & beef sauteed w/ seasoned veg. brown sauce.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Hunan Delight', 9.95)
        .setSpicy(true)
        .setDescription('Shrimp, chicken & beef in hunan brown sauce.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Sesame Chicken', 9.95)
        .setDescription('Deep fried chicken w/ sweet special sauce & sesame seeds.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('General Tso\'s Chicken', 9.95)
        .setSpicy(true)
        .setDescription('Chunk chicken meat sauteed in famous General Tso\'s light, hot spacy sauce.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Mongolian Triple', 9.95)
        .setDescription('Chicken, beef & shrimp w/ mongolian style sauce.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Orange Chicken', 9.95)
        .setSpicy(true)
        .setDescription('Deep fried chicken w/ orange sauce.')
        .setServingOptions(1)
        .setAddOns(...addOnOptions).build())